module.exports = __webpack_public_path__ + "img/item7-1.c300330a.jpg";